<template>
<div class="flex">
    <div class="w-1/3 mb-6 mr-2">
        <label class="invisible" for="image">
            Image*
        </label>
        <input type="file" @change="processFile($event)" @input="updateForm">
    </div>

    <div class="w-1/3 mb-6 mr-2">
        <label class="invisible" for="url">
            Url*
        </label>
        <input class="w-full shadow appearance-none border rounded py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
            id="url" type="text" name="url" placeholder="Url"
            v-validate="'required'"
            v-model="url"
            @input="updateForm">
        <span v-show="errors.has('url')" class="error text-error-red text-lg">{{ errors.first('url') }}</span>
    </div>

    <div class="w-1/3 mb-6 mr-2">
        <label class="invisible" for="title">
            Title*
        </label>
        <input class="w-full shadow appearance-none border rounded py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
            id="title" type="text" name="title" placeholder="Title"
            v-validate="'required'"
            v-model="title"
            @input="updateForm">
        <span v-show="errors.has('title')" class="error text-error-red text-lg">{{ errors.first('title') }}</span>
    </div>
</div>
</template>
<script>

    export default {
        name: 'EventLogoItem',
        data: () => ({
            image: {
                contents: '',
                name: ''
            },
            url: '',
            title: ''
        }),
        computed: {},
        methods: {
            processFile(e) {
                if (!e.target.files.length) {
                    return;
                }

                const file = e.target.files[0];

                let reader = new FileReader();
                // let vm = this;

                reader.onload = (e) => {
                    let contents = e.target.result;
                    const name = file.name;

                    this.image = {
                        contents: btoa(contents),
                        name: name
                    }

                }
                // readAsBinaryString
                reader.readAsBinaryString(file);
            },
            updateForm(e) {
                this.$emit('input', e.target.value)
            }
        },
        mounted() {}
    }
</script>
